import {Helmet} from '@dr.pogodin/react-helmet';

import {useParams} from 'react-router-dom';

import {isNil} from 'ramda';
import {isNilOrEmpty} from 'ramda-adjunct';

import {useGetDispensingUnitPresetQuery} from '@dms/api/warehouse';
import i18n from '@dms/i18n';
import {settingsRoutes, testIds} from '@dms/routes';
import {SettingsTemplate, SettingsTemplateHeader} from '@dms/settings/shared';
import {usePermissions} from '@dms/shared';

import {DispensingUnitsPresetsDetailForm} from './components/DispensingUnitsPresetsDetailForm';

export function WarehousesDispensingUnitsPresetsDetail() {
  const {id} = useParams();

  const {
    data: dispensingUnitPreset,
    isLoading,
    isError,
  } = useGetDispensingUnitPresetQuery({codeListId: id as string}, {skip: isNilOrEmpty(id)});

  const [canCreateWarehouseDictionary, canEditWarehouseDictionary] = usePermissions({
    permissionKeys: ['warehouseDictionaryCreate', 'warehouseDictionaryEdit'],
  });

  //   Check edit permission only if id is not nil that means that the user is creating a new measurement unit
  const isEditDisabled = isNil(id) ? !canCreateWarehouseDictionary : !canEditWarehouseDictionary;

  const header: SettingsTemplateHeader = {
    title: isNil(id)
      ? i18n.t('entity.warehouse.actions.newDispensingUnitPreset')
      : (dispensingUnitPreset?.value.toString() ?? ''),
    breadcrumbs: [
      {
        label: i18n.t('entity.warehouse.labels.dispensingUnitsPresets'),
        href: settingsRoutes.warehousesDispensingUnitsPresets,
      },
    ],
    alerts: isEditDisabled
      ? [
          {
            type: 'banner',
            variant: 'info',
            message: i18n.t('module.warehouse.label.missingWarehouseDictionaryEditPermission'),
          },
        ]
      : undefined,
  };

  return (
    <>
      <Helmet title={i18n.t('entity.warehouse.labels.dispensingUnitPresetDetail')} />
      <SettingsTemplate
        header={header}
        isLoading={isLoading}
        isError={isError}
        data-testid={testIds.settings.warehousesDispensingUnitsPresetsDetail('template')}
      >
        <DispensingUnitsPresetsDetailForm
          dispensingUnitPreset={dispensingUnitPreset}
          isEditDisabled={isEditDisabled}
          data-testid={testIds.settings.warehousesDispensingUnitsPresetsDetail(
            'dispensingUnitsPresetsDetailForm'
          )}
        />
      </SettingsTemplate>
    </>
  );
}
